
import React, { useEffect } from 'react';

interface PerformanceOptimizationsProviderProps {
  children?: React.ReactNode;
}

// Simple provider that doesn't use any router-specific functionality
const PerformanceOptimizationsProvider = ({ children }: PerformanceOptimizationsProviderProps) => {
  // Check if we're in a browser environment
  const isClient = typeof window !== 'undefined';
  
  // On client-side, apply optimizations but without router hooks
  useEffect(() => {
    if (!isClient) return;
    
    // Initialize performance optimizations on first render
    const lazyLoadResources = () => {
      // Preconnect to external domains
      const preconnectDomains = [
        'https://fonts.googleapis.com',
        'https://fonts.gstatic.com',
        'https://assets.calendly.com'
      ];
      
      preconnectDomains.forEach(domain => {
        if (!document.querySelector(`link[rel="preconnect"][href="${domain}"]`)) {
          const link = document.createElement('link');
          link.rel = 'preconnect';
          link.href = domain;
          link.crossOrigin = 'anonymous';
          document.head.appendChild(link);
        }
      });
    };
    
    // Execute immediately
    lazyLoadResources();
    
    // Track performance metrics
    if (window.performance && 'PerformanceObserver' in window) {
      // Create a performance observer to monitor loading metrics
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (entry.entryType === 'largest-contentful-paint') {
            console.log('LCP:', entry.startTime);
          }
        });
      });
      
      // Observe LCP performance entries
      observer.observe({ type: 'largest-contentful-paint', buffered: true });
      
      return () => {
        observer.disconnect();
      };
    }
  }, [isClient]);
  
  return <>{children}</>;
};

export default PerformanceOptimizationsProvider;
